import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/vigilancia/zonas-sociales";

export const VigilanteZonasSocialesService = {
  // === ZONAS SOCIALES ===
  listarZonas: () => axiosInstance.get(`${BASE_URL}/`),

  // === CALENDARIO ===
  getCalendario: (start, end) =>
    axiosInstance.get(`${BASE_URL}/calendario/?start=${start}&end=${end}`),

  // === REPORTES DE AVERÍAS ===
  getReportesAverias: (reservaUuid) =>
    axiosInstance.get(`${BASE_URL}/reportes-averias/?reserva=${reservaUuid}`),

  crearReporteAveria: (data) =>
    axiosInstance.post(`${BASE_URL}/reportes-averias/`, data),
};

export default VigilanteZonasSocialesService;